import { Component, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent implements OnDestroy {

  signUpText: boolean = false;
  checkoutText: boolean = false;
  requestDemoText: boolean = false;

  constructor() {
    this.signUpText = this.convertToBoolean(sessionStorage.getItem('signUp'));
    this.checkoutText = this.convertToBoolean(sessionStorage.getItem('checkout'));
    this.requestDemoText = this.convertToBoolean(sessionStorage.getItem('requestDemoText'));
  }

  ngOnDestroy() {
    sessionStorage.removeItem('checkout');
    sessionStorage.removeItem('signUp');
    sessionStorage.removeItem('requestDemoText');
  }

  convertToBoolean(value: string): boolean
  {
    if (value === 'true') {
      return true;
    }
    return false;
  }

}
